module.exports = __webpack_public_path__ + "img/Kenya.eeafe595.svg";